var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.avatarUrl)?_c('img',{staticClass:"rounded-full",attrs:{"src":_vm.avatarUrl,"alt":_vm.avatarTitle}}):_c('img',{staticClass:"rounded-full",attrs:{"src":require("../../../common/assets/img/jobibot.png"),"alt":"Jobibot"}})
}
var staticRenderFns = []

export { render, staticRenderFns }